import { useEffect, useState } from "react";
import {fetchCmlInfo} from "../../../api/cmlApi";
import { toast } from "react-toastify";


function useFetchCMLInfo(cmlID) {

    const [infopanelData, setInfoPanelData] = useState();
    useEffect(() => {
        fetchCmlInfo(cmlID).then((data) => {
            setInfoPanelData(data[0]);
        }).catch((error) => {
            console.error("Error fetching CML info:", error);
            toast.error("Cannot fetch CML info");
        }
        );
    }, [cmlID]);

    return infopanelData;
}

export default useFetchCMLInfo;